module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-IGZO-Mobility-1.dc282ee0.png";